module.exports = __webpack_public_path__ + "img/avatar.febd67d2.png";